import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import PlusIcon from 'apollo-react-icons/Plus';
import React, { useState } from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUITA } from '../../utils/commonUtils';
import { ADD_NEW_BUTTON_LABEL } from '../constants/report-designer.constants';

const useStyles = makeStyles({
  root: {
    minHeight: 25,
    position: 'relative',
    width: '100%',
    paddingTop: 10,
  },
  hover: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    minHeight: 10,
    display: 'flex',
    flexDirection: 'row',
    '& button': {
      zIndex: 1000,
      height: '24px',
    },
    '&:before': {
      content: '""',
      flex: '1 1',
      borderBottom: '3px solid #0768fd',
      margin: 'auto',
    },
    '&:after': {
      content: '""',
      flex: '6 1',
      borderBottom: '3px solid #0768fd',
      margin: 'auto',
    },
  },
});

const AddNewControl = ({ controlType, onClick = () => {} }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const [isHovered, setIsHovered] = useState(false);

  const buttonLabel = ADD_NEW_BUTTON_LABEL[controlType]
    ? `Add ${ADD_NEW_BUTTON_LABEL[controlType]}`
    : 'Add Control';

  const handleAddButtonClick = (e) => {
    onClick();
    e.stopPropagation();
  };

  return (
    <div
      className={classes.root}
      onMouseEnter={(e) => {
        e.stopPropagation();
        setIsHovered(true);
      }}
      onMouseLeave={(e) => {
        e.stopPropagation();
        setIsHovered(false);
      }}
    >
      {isHovered && (
        <div className={classes.hover}>
          <Button
            variant="primary"
            icon={<PlusIcon />}
            size="small"
            onClick={handleAddButtonClick}
            ui-ta={getUITA('AddControlButton')}
          >
            {translateString(buttonLabel)}
          </Button>
        </div>
      )}
    </div>
  );
};

export default AddNewControl;
